import { Component, HostBinding, Input, Output, EventEmitter, HostListener, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';
import { DynamicComponentService } from 'src/app/service/dynamicComponent.service';
import { TranslateService } from '@ngx-translate/core';
import { RoService } from 'src/app/service/ro.service';
import { ThemeService } from 'src/app/service/theme.service';
import { DataService } from 'src/app/service/data.service';

////////////////////////////////////////
@Component({
    selector: 'alert2',
    template: `
<div
    class="container" [class.uiVersion1]="uiVersion==1" [ngStyle]="containerStyle" [style.--section-maincolor]="containerStyle['--section-maincolor'] || null"
    [style.maxWidth]="(templateContent ? '100%' : containerMaxWidth)"
>
    <div class="alert-header" *ngIf="options.header" [ngStyle]="options.header.style">
		<span *ngIf="options.header.text">{{ options.header.text }}</span>
	</div>
	<span *ngIf="message" [ngStyle]="msgStyle" class="message">{{message}}</span>
    <ng-container *ngTemplateOutlet="templateContent"></ng-container>

    <div *ngFor="let row of btns" class="btnArea" [ngStyle]="btnAreaStyle">
        <div
            *ngFor="let btn of row; let first=first; let last=last;"
            class="btn"
            [class.single]="first && last"
            [ngStyle]="btn.ngStyle"
            (click)="execute(btn)"
        >
            {{btn.label || (btn.labelKey | translate)}}
        </div>
    </div>
    
</div>
    `,
    styleUrls: ['./alert2.component.scss']
})

export class Alert2Component implements OnInit{
    @HostListener('dblclick', []) onDblClick() { console.log(this); }
    @HostBinding('style.backgroundColor') public hostBackgroundColor:string;
    @HostBinding('style.zIndex') public hostZIndex = 0;
	@Input() options:any = {};
    
	public defBtns:any = {
		ok: { key:'ok', labelKey:"alert.ok", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
		yes: { key:'yes', labelKey:"alert.yes", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
		no: { key:'no', labelKey:"alert.no", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
		edit: { key:'edit', labelKey:"alert.edit", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
		later: { key:'later', labelKey:"alert.later", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
		cancel: { key:'cancel', labelKey:"alert.cancel", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
		delete: { key:'delete', labelKey:"alert.delete", ngStyle:{backgroundColor:"var(--alert-deletebuttontcolor)"} },
		archive: { key:'archive', labelKey:"alert.archive", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
		leave: { key:'leave', labelKey:"alert.leave", ngStyle:{backgroundColor:"var(--section-maincolor)"} },
		"save&leave": { key:'save&leave', labelKey:"alert.save&leave", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
		"discard&leave": { key:'discard&leave', labelKey:"alert.discard&leave", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
		"submit&leave": { key:'submit&leave', labelKey:"alert.submit&leave", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
		"notSubmit&leave": { key:'notSubmit&leave', labelKey:"alert.notSubmit&leave", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} }

    }
    @Input() public uiVersion:number = 0;
    @Input() public message:string = "";
	@Input() public msgStyle:any = {};
	@Input() public containerStyle:any = {};
	@Input() public btnAreaStyle: any = {};
    @Input() public btns:any[] = [
      [ this.defBtns.ok, this.defBtns.cancel ]
    ];
    
    public templateContent:TemplateRef<any> = null;
    public _showShadow:boolean = true;
	@Input() public containerMaxWidth = '300px';
    @Output() btnClick:EventEmitter<any> = new EventEmitter();

    private showingShadow:boolean = false;

    private isReady:boolean = false;
    constructor(
      private coms:CommonService,
      private dcs:DynamicComponentService,
      public translate:TranslateService,
      private ros:RoService,
      public themeService:ThemeService,
      public eleRef:ElementRef,
	  public datas: DataService
    ) {
		this.loadTheme();
    }

	ngOnInit(): void {
		let t = this.datas.t;
		let textMap = [
			{key: 'cancel', labelKey: t('取消','取消','Cancel')},
			{key: 'delete', labelKey: t('刪除','刪除','Delete')},
		];
		for (let prop in this.defBtns) {
			const btn = this.defBtns[prop];
			let found = textMap.find(item => item.key == prop);
			if (found) {
				btn.labelKey = found.labelKey;
			}
		}

	}

	private loadTheme() {
		this.themeService.reloadSetting();
		this.themeService.applyStyleObj({
			"default": {
				"alert-bgcolor": "#FFFFFF",
				"alert-roundcorners": "20px",
				"alert-minheight": "180px",
				"alert-textsize": "16px",
				"alert-textlineheight": "?",
				"alert-textcolor": "#000000",
				"alert-textxmargin": "20px",
				"alert-textymargin": "50px",
				"alert-buttonmargin": "12px",
				"alert-buttoncentermagin": "14px",
				"alert-buttonroundcorners": "10px",
				"alert-buttontextsize": "20px",
				"alert-buttontextweight": "bold",
				"alert-buttontextmargin": "8px",
				"alert-buttonvertextsize": "20px",
				"alert-buttonvertextweight": "bold",
				"alert-buttonvertextymargin": "12px",
				"alert-buttonwidth": "132px",
				"alert-buttonheight": "38px",
				"alert-okbuttoncolor": "var(--section-maincolor, #999)",
				"alert-cancelbuttoncolor": "#BEBEBE",
				"alert-deletebuttontcolor": "#DF3354",
				"alert-buttontextcolor": "#FFFFFF",
				"alert-shadow": "0px 5px 30px rgba(0,0,0,0.3)",
				"alert-rowcolor": "#E9E9E9",
				"alert-linecolor": "#CCCCCC"
			},
			"light": {},
			"dark": {
				"alert-textcolor": "#FFFFFF",
				"alert-bgcolor": "#2D2C43",
				"alert-cancelbuttoncolor": "#1E1E29",
				"alert-rowcolor": "#38374F",
				"alert-linecolor": "#53536A"
			}
		}, this.eleRef.nativeElement);
		this.isReady = true;
	}

    public open(appendEle:HTMLElement=document.body, retry:number=50):void {
      if (this.isReady) {
        this.hostBackgroundColor = this._showShadow ? 'rgba(0, 0, 0, 0.5)' : 'none';
		if (this.hostZIndex === 0){
			this.hostZIndex = this.coms.getMaxZIndex();
		}
        this.setDefBtns();
        this.dcs.open(this, appendEle);
        if (this._showShadow) {
            if (localStorage.getItem('in-web') == '0' || !this.datas.isInWeb) this.ros.request("showShadow", null, false).catch(e=> e);
            this.showingShadow = true;
        }
      } else if (retry>0) {
		this.loadTheme();
        setTimeout(()=>this.open(appendEle, retry-1), 100);
      }
    }

    private setDefBtns():void {
		this.defBtns = {
			ok: { key:'ok', labelKey:"alert.ok", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
			yes: { key:'yes', labelKey:"alert.yes", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
			no: { key:'no', labelKey:"alert.no", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
			edit: { key:'edit', labelKey:"alert.edit", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
			later: { key:'later', labelKey:"alert.later", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
			cancel: { key:'cancel', labelKey: this.datas.t('取消','取消','Cancel'), ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
			delete: { key:'delete', labelKey: this.datas.t('刪除','刪除','Delete'), ngStyle:{backgroundColor:"var(--alert-deletebuttontcolor)"} },
			archive: { key:'archive', labelKey:"alert.archive", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
			leave: { key:'leave', labelKey:"alert.leave", ngStyle:{backgroundColor:"var(--section-maincolor)"} },
			"save&leave": { key:'save&leave', labelKey:"alert.save&leave", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
			"discard&leave": { key:'discard&leave', labelKey:"alert.discard&leave", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} },
			"submit&leave": { key:'submit&leave', labelKey:"alert.submit&leave", ngStyle:{backgroundColor:"var(--alert-okbuttoncolor)"} },
			"notSubmit&leave": { key:'notSubmit&leave', labelKey:"alert.notSubmit&leave", ngStyle:{backgroundColor:"var(--alert-cancelbuttoncolor)"} }
		};
		if(!this.btns) // 無設定先用預設
			this.btns = [
				[ this.defBtns.ok, this.defBtns.cancel ]
			];
      for (let row of this.btns) {
        for (let i=0; i<row.length; i++) {
          let btn = row[i];
          if ((typeof btn == 'string') && this.defBtns[btn]) {
            row[i] = this.defBtns[btn];
          }
        }
      }
    }

	async execute(btn:any)
	{
		await this.close();
		this.btnClick.emit(btn.key);
	}
	

    public async close(){
        this.dcs.close(this);
        if (this.showingShadow && (localStorage.getItem('in-web') == '0' || !this.datas.isInWeb) ) {
			try{
				await this.ros.request("hideShadow", null, false);
			} catch(reason)
			{

			}
		}
    }

}


class StyleCache {
	public static styleObj: any = {};
}
